<template>
	<div>
		<ol class="step-indicator" v-if="!isLastStep">
			<li v-for="step in steps" :key="step.id" :class="indicatorClass(step.id)">
				<div class="step" @click="onStepNavClick(step.id)">{{ step.id }}</div>
				<div class="caption"><span v-text="step.title"></span></div>
				<div class="step-separator"></div>
			</li>
		</ol>
		<slot></slot>
	</div>
</template>
<script>
export default {
	name: "stepper",
	props: {
		steps: Array,
		currentStep: Number,
		hideOnLastStep: {
			type: Boolean,
			default: false,
		},
	},
	data: function () {
		return {
			lastStepId: this.steps.slice(-1)[0].id
		}
	},
	computed: {
		isLastStep() {
			return this.hideOnLastStep && this.currentStep === this.lastStepId;
		},
	},
	methods: {
		indicatorClass(stepId) {
			return {
				active: stepId === this.currentStep,
				complete: this.currentStep > stepId,
				last: this.currentStep === this.steps.length
			};
		},
		onStepNavClick(stepIdClicked) {
			this.$emit('step-change', stepIdClicked);
		},
	}
};
</script>
